import * as React from 'react'
import TextContainer from '../../layout/TextContainer';
import { TerminalNodeInterpreter } from '../model/TerminalNodeInterpreter';
import { TerminalScoreContext } from '../TerminalScoreProvider';
import TerminalHeuristicsTable from './TerminalHeuristicsTable';
import TerminalMaximumDisableRatio from './TerminalMaximumDisableRatio';
import TerminalMinimumActiveChannelCount from './TerminalMinimumActiveChannelCount';
import TerminalMinimumMedianCapacity from './TerminalMinimumMedianCapacity';
import TerminalMinimumStableInPeers from './TerminalMinimumStableInPeers';
import TerminalMinimumStableOutPeers from './TerminalMinimumStableOutPeers';
import TerminalUptimeProblem from './TerminalUptimeProblem';


type Props = {
  nodeId: string,
  className?: string
}

const TerminalHeuristics: React.FC<Props> = ({ nodeId, className = '' }) => {
  const { graph, terminalScore } = React.useContext(TerminalScoreContext);

  const terminalNode = terminalScore.getNode(nodeId);
  const interpreter = new TerminalNodeInterpreter(terminalNode);
  const nodeStatus = terminalScore.getNodeStatus(nodeId);


  const quickNumbersClasses = 'px-6 py-4'

  return (
    <div className={' ' + className}>
      <div>

        <TextContainer className="">
          <h2 id="node-heuristics" className="text-xl font-bold mb-2 text-gray-800">Node heuristics</h2>
          <p>
            Heuristics are basic requirements to make your node rank in the score.
            If only one single heuristic is not matched your node will drop in rank heavily.
          </p>
        </TextContainer>

        <div className="flex flex-wrap justify-center container mx-auto mt-8">
          <div className="relative border rounded  pb-2 mt-4 bg-white">
            <div className="flex flex-wrap justify-center items-center">
              <TerminalMaximumDisableRatio className={quickNumbersClasses} nodeId={nodeId} />
              <TerminalMinimumActiveChannelCount className={quickNumbersClasses} nodeId={nodeId} />
              <TerminalMinimumMedianCapacity className={quickNumbersClasses} nodeId={nodeId} />
              <TerminalUptimeProblem className={quickNumbersClasses} nodeId={nodeId} />
            </div>
            <p className="absolute bottom-0 ml-4 bg-white px-1 text-gray-400 text-xs" style={{ marginBottom: '-0.7em' }}>Stable</p>
          </div>
          <div className="px-2"></div>
          <div>

          </div>
          <div className="relative border rounded pb-2 mt-4 bg-white">
            {(nodeStatus === 'stable' || nodeStatus === 'scored') &&
              <div className="flex flex-wrap justify-center">
                <TerminalMinimumStableInPeers className={quickNumbersClasses} nodeId={nodeId} />
                <TerminalMinimumStableOutPeers className={quickNumbersClasses} nodeId={nodeId} />
              </div>
            }

            {nodeStatus === 'unstable' &&
              <div className="text-gray-700 px-8 py-4 h-full flex items-center justify-center" style={{maxWidth: '300px'}}>
                <div className="text-sm">Only nodes that pass the <span className="italic">stable</span> heuristics are evaluated for the <span className="italic">good</span> heuristics.</div>
              </div>
            }

            <p className="absolute bottom-0 ml-4 bg-white px-1 text-gray-400 text-xs" style={{ marginBottom: '-0.7em' }}>Good</p>
          </div>
        </div>


        <TextContainer className="mt-24">
          <TerminalHeuristicsTable />
        </TextContainer>

      </div>
    </div>
  );
}

export default TerminalHeuristics;

